import api from "../index";

// Get referral info for the current user
export const getUserReferralInfo = async () => {
  return await api.get("/referrals");
};

// Invite a user via email
export const inviteUser = async (data: { email: string }) => {
  return await api.post("/referrals/invite", data);
};

// Process a referral when signing up
export const processReferral = async (data: { referralCode: string }) => {
  return await api.post("/referrals/process", data);
};

// Remove an invitation
export const removeInvitation = async (data: { email: string }) => {
  return await api.post("/referrals/remove", data);
};

// Get gamification summary (referrals + achievements)
export const getGamificationSummary = async () => {
  return await api.get("/gamification");
};